import React from "react";
import { Link } from "react-router-dom";

// Full-width service record: photo on one side, panel on the other, alternating
// per row. Deliberately not the same shape as AnaMenu's two-up DoorCards — the
// services page is the detailed listing, so each service gets a full row.
export default function ServiceRecord({ img, imgPosition, index, title, body, href, cta, flip = false }) {
  return (
    <Link
      to={href}
      className="group grid md:grid-cols-12 border border-line bg-white rounded-sm overflow-hidden transition-colors duration-300 hover:border-linestrong focus-visible:outline focus-visible:outline-2 focus-visible:outline-royal focus-visible:outline-offset-2"
    >
      <div
        className={`md:col-span-5 relative h-[240px] md:h-auto md:min-h-[320px] overflow-hidden ${
          flip ? "md:order-2" : ""
        }`}
      >
        <img
          src={img}
          alt=""
          loading="lazy"
          style={imgPosition ? { objectPosition: imgPosition } : undefined}
          className="absolute inset-0 w-full h-full object-cover saturate-[0.45] transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:saturate-100 group-hover:scale-[1.04]"
        />
        <div
          aria-hidden="true"
          className="absolute inset-0 bg-gradient-to-t from-navy/45 via-transparent to-transparent pointer-events-none"
        />
      </div>

      <div className={`md:col-span-7 relative p-7 sm:p-10 flex flex-col ${flip ? "md:order-1" : ""}`}>
        {/* Royal edge opens on hover — the same device as the record rows. */}
        <span
          aria-hidden="true"
          className="absolute left-0 top-0 bottom-0 w-[3px] bg-royal origin-top scale-y-0 transition-transform duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-y-100"
        />
        <span className="font-hanken font-bold uppercase text-[10.5px] tracking-[0.13em] text-steel/70">
          {index}
        </span>
        <h2 className="mt-3 font-hanken font-extrabold text-ink tracking-[-0.02em] text-[26px] sm:text-[30px] leading-tight">
          {title}
        </h2>
        <p className="mt-4 max-w-xl text-[16px] leading-[1.75] text-steel">{body}</p>
        <span className="mt-auto pt-7 inline-flex items-center gap-2 font-hanken font-bold text-[15px] text-royal">
          {cta}
          <span
            aria-hidden="true"
            className="inline-block transition-transform duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:translate-x-1"
          >
            →
          </span>
        </span>
      </div>
    </Link>
  );
}
